import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconLbi = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconLbi"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M13.517 12.67h9.61a.883.883 0 0 1 .76 1.323l-4.688 8.155a1.71 1.71 0 0 1-1.481.86H7.05a1.71 1.71 0 0 1-1.481-.86l-5.335-9.28a1.72 1.72 0 0 1 0-1.72l5.336-9.28a1.71 1.71 0 0 1 1.48-.86h10.667a1.71 1.71 0 0 1 1.48.86l4.688 8.156a.883.883 0 0 1-.76 1.323h-9.61a1.31 1.31 0 0 1-1.13-.657L8.859 4.548a.44.44 0 0 0-.606-.164l-.375.217a.45.45 0 0 0-.163.608l3.528 6.142a1.31 1.31 0 0 1 0 1.313l-3.528 6.144a.45.45 0 0 0 .163.608l.375.217a.445.445 0 0 0 .606-.164l3.528-6.142a1.3 1.3 0 0 1 1.13-.657" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconLbi);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
